import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { Data } from "../constants/data";

export const Gallery: React.FC<{ data: Data }> = ({ data }) => {
  const [scrollBack, setScrollBack] = useState(false);
  const [enlarged, setEnlarged] = useState<string | null>(null);
  const [isEnlargedLoaded, setIsEnlargedLoaded] = useState(false);
  const imgRef = useRef<HTMLDivElement>(null);
  const galleryRef = useRef<HTMLUListElement>(null);
  useEffect(() => {
    if (enlarged) {
      imgRef?.current?.scrollIntoView({ behavior: "smooth" });
      setScrollBack(false);
    } else if (scrollBack) {
      galleryRef?.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [enlarged, imgRef, galleryRef]);

  const handleClose = () => {
    setEnlarged(null);
    setIsEnlargedLoaded(false);
    setScrollBack(true);
  };
  const handleLoaded = () => {
    setIsEnlargedLoaded(true);
  };
  return (
    <div className="flex flex-col gap-4">
      <ul
        ref={galleryRef}
        className="flex w-full gap-3 p-4 overflow-x-auto lg:px-0"
      >
        {data.images.map((imageUrl, i) => {
          return (
            <div
              key={imageUrl}
              className="overflow-hidden transition-shadow rounded-md cursor-pointer bg-gray-50 hover:shadow-lg"
              style={{ height: 200, width: 350, flexShrink: 0 }}
              onClick={() => setEnlarged(imageUrl)}
            >
              <Image
                height={200}
                width={350}
                title="enlarge"
                key={`${data.title}-${i}-image`}
                className="object-cover"
                src={imageUrl}
                alt={`${data.title}-images`}
              />
            </div>
          );
        })}
      </ul>

      {enlarged && (
        <div
          ref={imgRef}
          className={`relative w-screen h-screen max-w-screen-lg ${
            isEnlargedLoaded ? "" : "bg-gray-50 animate-pulse"
          }`}
        >
          <Image
            src={enlarged}
            layout="fill"
            className="object-contain"
            onLoadingComplete={handleLoaded}
          />

          <button
            onClick={handleClose}
            className="absolute p-4 font-bold tracking-wider bg-white lg:p-0 right-2 top-4"
          >
            close
          </button>
        </div>
      )}
    </div>
  );
};
